import React, {useContext} from 'react';
import {CookieConsent} from 'react-cookie-consent';
import {CookieContext} from '../contexts/CookieContext';
import {Plan} from '../types/Plan';

interface Props {
    onAccept: () => void;
    onDecline: () => void;
    visible: boolean;
}
export const MyCookieConsent: React.FC<Props> = ({onAccept, onDecline, visible}) => {
    const {cookieUrl} = useContext(CookieContext);

    let link;
    if (cookieUrl) {
        link = <a href={cookieUrl}>Více informací</a>;
    }

    return (
        <CookieConsent
            overlay
            enableDeclineButton
            visible={visible ? 'show' : 'hidden'}
            buttonText={'Souhlasím'}
            onAccept={() => onAccept()}
            onDecline={() => onDecline()}
            declineButtonText={'Nesouhlasím'}
            style={{backgroundColor: '#FF8800'}}
            buttonStyle={{borderRadius: 5, backgroundColor: '#0496FF', color: 'white', padding: '7px 10px 5px 10px', marginRight: 30}}
            declineButtonStyle={{
                borderRadius: 5,
                backgroundColor: 'white',
                color: 'black',
                borderWidth: 2,
                padding: '7px 10px 5px 10px',
            }}
        >
            Tento web používá k zajištění své funkčnosti a analýze návštěvnosti soubory cookie. {link}
        </CookieConsent>
    );
};
